import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {CurrencyFormatter, DiscountFormatter, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import {postData, sendRequest} from "../../../utils/request";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import isEqual from "lodash-es/isEqual";
import SupplyPurchaseReturnForm from "./Elements/SupplyPurchaseReturnForm";
import Button from "../../form/Button";
import CheckBox from "../../form/CheckBox";

/**
 * TODO nem találtam hogy ez valahol használatban is lenne, szerintem nem kell!
 */

const sortable = true;
const filterable = true;

const percentColors = [
    {pct: 0.0, color: {r: 216, g: 218, b: 255}},
    {pct: 0.5, color: {r: 245, g: 221, b: 187}},
    {pct: 1.0, color: {r: 255, g: 160, b: 160}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}

class SupplyPurchaseReturnEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "SupplyPurchaseReturn",
        filter: [
            {column: "preset", value: "SupplyPurchaseReturn"},
            {column: "saved", value: 1}
        ],
        actionButtons: [],
        //availablePaymentProviders: [],
        //availableShippingProviders: [],
        pool: {
            exports: [{as: "excel", label: "Excel", icon: "far fa-file-excel", filter: [{field: "pickedqty", operator: "not isnull"}]}],
            orderBy: {field: "displayname", direction: "ASC"},
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "nettotalprice": {
                        field: "nettotalprice", type: "SUM"
                    },
                    "totalsaleprice": {
                        field: "totalsaleprice", type: "SUM"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            component: "SalesPoolItem",
            view: ["id","product_id","saleprice","OperationList_id", "vat"],
            columns: {
                "displayname": {
                    ...ProductColumn("product_id"),
                    width: 1
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Lista ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                },
                "discount": {
                    header: "Kedvezmény",
                    width: 1,
                    sortable,
                    filterable,
                    className: "discount",
                    onHover: (e, field, value, purchaseitem) => {
                        this.hoverDebounce && this.hoverDebounce(purchaseitem.discount);
                    },
                    onLeave: (e, field, value, purchaseitem) => {
                        this.hoverDebounce && this.hoverDebounce(null);
                    },
                    columnCss: (field, value, purchaseitem, purchaseitems) => {
                        const current = parseFloat(purchaseitem.discount || 0).toFixed(2);
                        const percents = purchaseitems.map((purchaseitem) => parseFloat(purchaseitem.discount || 0).toFixed(2)).filter(function (item, pos, self) {
                            return self.indexOf(item) == pos;
                        }).sort();
                        const posPercent = parseFloat((percents.length - percents.indexOf(current)) / percents.length).toFixed(2);
                        //console.log((percents.length - percents.indexOf(current)) / percents.length);
                        return {
                            backgroundColor: getColorForPercentage(posPercent/*percents.indexOf(current) / percents.length*/),
                            fontWeight: this.state.hoverColumnValue == current ? "bold" : "normal"
                        }
                    },
                    renderer: DiscountFormatter,
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="discount" label={false} focus="focus"
                                           value={props.rowData.discount}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                />
                },
                "netsaleprice": {
                    header: 'Nettó egységár',
                    width: 1,
                    renderer: CurrencyFormatter,
                    className: "currency",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="netsaleprice" label={false} focus="focus"
                                           value={value}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
                "saleprice": {
                    header: 'Bruttó egységár',
                    width: 1,
                    renderer: CurrencyFormatter,
                    className: "currency",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="saleprice" label={false} focus="focus"
                                           value={value}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
                "stockqty": {
                    header: 'Raktárkészlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "pickedqty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
                "nettotalprice": {
                    header: 'Nettó összeg',
                    width: 1,
                    renderer: CurrencyFormatter,
                },
                "totalsaleprice": {
                    header: 'Bruttó összeg',
                    width: 1,
                    renderer: CurrencyFormatter,
                }
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadProviders();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.values, this.props.values)) {
            this.loadProviders();
        }
    }

    loadProviders = () => {
        return;
        this.availableShippings && this.availableShippings.abort();
        if ((this.props.values.pos || {}).id) {
            this.availableShippings = sendRequest({
                option: "componentlist",
                component: "ShippingServiceProvider",
                filter: [
                    {field: "pos", value: (this.props.values.pos || {}).id}
                ]
            });
            this.availableShippings.then((response) => {
                this.setState({
                    availableShippingProviders: response.items
                });
            });
        } else {
            this.setState({
                availableShippingProviders: []
            });
        }
        this.availablePayments && this.availablePayments.abort();
        if ((this.props.values.pos || {}).id && (this.props.values.shipping || {}).serviceprovider_type) {
            this.availablePayments = sendRequest({
                option: "componentlist",
                component: "PaymentServiceProvider",
                filter: [
                    {field: "pos", value: (this.props.values.pos || {}).id},
                    {field: "shipping", value: (this.props.values.shipping || {}).serviceprovider_type},
                ]
            });
            this.availablePayments.then((response) => {
                this.setState({
                    availablePaymentProviders: response.items
                });
            });
        } else {
            this.setState({
                availablePaymentProviders: []
            });
        }
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
        };
        props.actionButtons = [
            <Button
                key="4"
                disabled={props.isLoading || !props.values.id}
                color="primary"
                icon={{lib: "fa", name: "money"}}
                className="pull-right"
                onClick={async (e) => {
                    const values = props.values;
                    values.autocheckup = true;
                    await props.processAction(async () => {
                        const response = await postData({
                            action: 'OperationList.doAction',
                            actionname: 'create',
                            data: await referenceActionData(values, this.props.componentConfig)
                        });
                        await this.props.pristineForm(false);
                        return response;
                    });
                }}
            >
                Eladás
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (props.values && props.values.customer) {
            props.pool.visible = true;
            props.pool.parameters.store = props.values.source.id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = props.values.customer.partner_id;
        } else {
            props.pool.visible = false;
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter = [{field: "pickedqty", operator: "not isnull"}];
        } else {
            props.pool.filter = [];
        }
        props.pool.paginatorRight = <CheckBox onIcon={{lib: "fa", name: "box"}} offIcon={{lib: "fa", name: "box-open"}} value={this.state.filtered} label={false} saveChanges={(field, value) => {
            this.setState({filtered: !!value});
        }} />;
        return props;
    }

    renderer = (componentProps) => {
        return <SupplyPurchaseReturnForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} />;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: SupplyPurchaseReturnEditor,
    editor: "SupplyPurchaseReturn",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        //componentAction: "createpurchase",
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "SupplyPurchaseReturn";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});